/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob16IndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob16IndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false
});

export const whseJob16IndexFetchWhseJob16IndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob16IndexFetchWhseJob16IndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob16IndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const whseJob16IndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob16IndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob16IndexTypes.WHSE_JOB16_INDEX_RESET_TIMESTAMP]: whseJob16IndexResetTimestamp,
  [WhseJob16IndexTypes.WHSE_JOB16_INDEX_FETCH_WHSE_JOB16_INDEX_LOADING]: whseJob16IndexFetchWhseJob16IndexLoading,
  [WhseJob16IndexTypes.WHSE_JOB16_INDEX_FETCH_WHSE_JOB16_INDEX_SUCCESS]: whseJob16IndexFetchWhseJob16IndexSuccess,
  [WhseJob16IndexTypes.WHSE_JOB16_INDEX_ADD_SELECTED_DOCUMENTS]: whseJob16IndexAddSelectedDocuments,
  [WhseJob16IndexTypes.WHSE_JOB16_INDEX_REMOVE_SELECTED_DOCUMENTS]: whseJob16IndexRemoveSelectedDocuments,
  [WhseJob16IndexTypes.WHSE_JOB16_INDEX_SET_WORKSPACE_VISIBLE]: whseJob16IndexSetWorkspaceVisible
});
